import React, { useState, useEffect } from "react";
import "./Recon.css";
// import ReconDashHeader from "./ReconDashHeader";
import { ShimmerSimpleGallery } from "react-shimmer-effects";
import { getReconDashboardData } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import ReconFirstSection from "./ReconFirstSection";
import ReconSecondSection from "./ReconSecondSection";
import { FaCalendar } from "react-icons/fa6";
import { DateRangePicker } from "react-date-range";
import DownloadReportModal from "../downloadReport/Modal";
import DateFilter from "../../../components/common/DateFilter";

const ReconDashboard = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [count, setCount] = useState("");
  const [amount, setAmount] = useState("");
  const [penalty, setPenalty] = useState("");
  const [showGenerateReport, setShowGenerateReport] = useState(false);
  const token = useSelector((store) => store.userReducer.token);

  const fetchReconDashboard = async (token, startDate, endDate) => {
    setIsLoading(true);

    const response = await getReconDashboardData(token, startDate, endDate);

    setCount(response.count);
    setAmount(response.amount);
    setPenalty(response.penalty);

    setIsLoading(false);
  };

  const handleDateChange = (start, end) => {
    fetchReconDashboard(token, start, end);
  };

  return (
    <>
      <div className="recon-main-header">
        {/* <ReconDashHeader /> */}
        <div className="recon-main-header">
          <h2>Chargeback Dashboard</h2>
        </div>
      </div>
      <DateFilter onDateChange={handleDateChange} />

      <div className="download-report-recon">
        <div className="">
          <h2>Download Reports</h2>
        </div>
        <div className="download-report-head">
          <button
            className="btn-report-recon"
            onClick={() => setShowGenerateReport(true)}
          >
            Generate Report
          </button>
        </div>
      </div>

      <>
        {isLoading ? (
          <ShimmerSimpleGallery
            className="shimmer-effect"
            row={1}
            col={3}
            imageHeight={200}
          />
        ) : (
          <ReconFirstSection count={count} amount={amount} penalty={penalty} />
        )}

        {isLoading ? (
          <ShimmerSimpleGallery
            className="shimmer-effect"
            row={1}
            col={1}
            imageHeight={200}
          />
        ) : (
          <ReconSecondSection amount={amount} penalty={penalty} />
        )}
      </>
      {showGenerateReport && (
        <DownloadReportModal onClose={() => setShowGenerateReport(false)} />
      )}
    </>
  );
};

export default ReconDashboard;
